// extracted by mini-css-extract-plugin
export default {"likeButton":"qK-z","unLikedButton":"rK-z","likedButton":"sK-z"};